import {
  getEarningsSummary,
  getEarningsTrend,
  getEarningsDetail,
  getWorkEarnings,
  getWithdrawRecords,
  applyWithdraw
} from '@/api/earnings'

const state = {
  summary: {
    total: 0,
    adIncome: 0,
    payIncome: 0,
    balance: 0,
    pending: 0
  },
  trend: [],
  detailList: [],
  workEarnings: [],
  withdrawRecords: [],
  detailTotal: 0,
  loading: false,
  filters: {
    page: 1,
    limit: 10,
    startDate: '',
    endDate: '',
    type: ''
  }
}

const mutations = {
  SET_SUMMARY: (state, summary) => {
    state.summary = summary
  },
  SET_TREND: (state, trend) => {
    state.trend = trend
  },
  SET_DETAIL_LIST: (state, list) => {
    state.detailList = list
  },
  SET_WORK_EARNINGS: (state, list) => {
    state.workEarnings = list
  },
  SET_WITHDRAW_RECORDS: (state, records) => {
    state.withdrawRecords = records
  },
  SET_DETAIL_TOTAL: (state, total) => {
    state.detailTotal = total
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading
  },
  SET_FILTERS: (state, filters) => {
    state.filters = { ...state.filters, ...filters }
  },
  RESET_FILTERS: (state) => {
    state.filters = {
      page: 1,
      limit: 10,
      startDate: '',
      endDate: '',
      type: ''
    }
  },
  ADD_WITHDRAW_RECORD: (state, record) => {
    state.withdrawRecords.unshift(record)
    // 更新余额
    state.summary.balance -= record.amount
    state.summary.pending += record.amount
  }
}

const actions = {
  // 获取收益概览
  getEarningsSummary({ commit }) {
    return new Promise((resolve, reject) => {
      getEarningsSummary().then(response => {
        const { data } = response
        commit('SET_SUMMARY', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取收益趋势
  getEarningsTrend({ commit }, params) {
    return new Promise((resolve, reject) => {
      getEarningsTrend(params).then(response => {
        const { data } = response
        commit('SET_TREND', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取收益明细
  getEarningsDetail({ commit, state }) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      getEarningsDetail(state.filters).then(response => {
        const { data, total } = response
        commit('SET_DETAIL_LIST', data)
        commit('SET_DETAIL_TOTAL', total)
        resolve(response)
      }).catch(error => {
        reject(error)
      }).finally(() => {
        commit('SET_LOADING', false)
      })
    })
  },

  // 获取作品收益排行
  getWorkEarnings({ commit }, params) {
    return new Promise((resolve, reject) => {
      getWorkEarnings(params).then(response => {
        const { data } = response
        commit('SET_WORK_EARNINGS', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取提现记录
  getWithdrawRecords({ commit }, params) {
    return new Promise((resolve, reject) => {
      getWithdrawRecords(params).then(response => {
        const { data } = response
        commit('SET_WITHDRAW_RECORDS', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 申请提现
  applyWithdraw({ commit }, withdrawData) {
    return new Promise((resolve, reject) => {
      applyWithdraw(withdrawData).then(response => {
        const { data } = response
        commit('ADD_WITHDRAW_RECORD', {
          ...data,
          date: new Date().toLocaleString(),
          status: 'processing',
          statusText: '处理中'
        })
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 设置筛选条件
  setFilters({ commit }, filters) {
    commit('SET_FILTERS', filters)
  },

  // 重置筛选条件
  resetFilters({ commit }) {
    commit('RESET_FILTERS')
  },

  // 清空数据
  clearEarningsData({ commit }) {
    commit('SET_SUMMARY', { total: 0, adIncome: 0, payIncome: 0, balance: 0, pending: 0 })
    commit('SET_TREND', [])
    commit('SET_DETAIL_LIST', [])
    commit('SET_WORK_EARNINGS', [])
    commit('SET_WITHDRAW_RECORDS', [])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}